import { Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BannerComponent } from "./component/banner/banner.component";
import { FooterComponent } from "./component/footer/footer.component";
import { ContactComponent } from "./component/sections/contact/contact.component";
import { NotificationBarComponent } from "./component/sections/notificationbar/notificationbar.component";
import { NotificationBarModel } from './component/sections/notificationbar/notificationbar.model';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BannerComponent, FooterComponent, ContactComponent, NotificationBarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {

  title = 'jayteewashington-app';

  constructor() {}

  onNotificationAction(event: NotificationBarModel) {
    console.log('onNotificationAction->', event)
  }
}
